import { Component } from 'react'

import { TimeFrames } from './types'

interface MenuProps<Key> {
  isDetailOpen?: boolean
  activePage: string
  timeframes: TimeFrames<Key>
  company?: string
}

class Menu<Key extends string> extends Component<MenuProps<Key>> {
  render() {
    var { activePage } = this.props
    var timeframesMenu = this.props.timeframes

    return (
      <div className="menu">
        <ul className="menu-pages">
          <li className={activePage === 'quotes' ? 'is-active' : ''}>
            <a href="/crypto.ashx">Quotes</a>
          </li>
          <li className={activePage === 'performance' ? 'is-active' : ''}>
            <a href="/crypto_performance.ashx">Performance</a>
          </li>
          <li className={activePage === 'charts' ? 'is-active' : ''}>
            <a href="/crypto_charts.ashx">Charts</a>
          </li>
        </ul>

        <ul className="menu-timeframes">
          {timeframesMenu.timeframes.map((timeframe) => (
            <li className={timeframesMenu.active === timeframe.key ? 'is-active' : ''} key={timeframe.key}>
              <a
                href={timeframesMenu.link(timeframe.key as Key)}
                onClick={timeframesMenu.onClick.bind(this, timeframe.key as Key)}
                title={timeframe.title}
              >
                {timeframe.value}
              </a>
            </li>
          ))}
        </ul>
      </div>
    )
  }
}

export default Menu
